import { Faq } from '../faq/Faq';
import { Form } from '../forms/Forms';
import GForm from '../gforms/GForm';
import HTMLContent from '../globals/HTMLContent';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { HouseAuthor } from '../house/HouseAuthor';

interface NewsModalProps {
  news: any;
  differenceTime: string;
  authorImgUrl: string;
  houseName: string;
}

export const NewsModalContent: React.FC<NewsModalProps> = ({
  news,
  differenceTime,
  authorImgUrl,
  houseName,
}) => {
  return (
    <div className="bg-white md:rounded-3xl md:p-5 h-auto">
      <img
        className="h-96 w-full object-cover bg-lightGrey md:rounded-3xl"
        src={news?.thumbnail_img}
        alt=""
      />
      <div className="rounded-t-3xl -mt-7 bg-white modal-news-content py-10 relative z-10 px-5 md:-mt-0">
        <div className="news-header">
          <SanitizeHTML
            tag="h1"
            html={news?.title}
            className="text-left text-2xl font-bold mb-4 text-black"
          />
          <HouseAuthor
            authorImgUrl={authorImgUrl}
            houseName={houseName}
            differenceTime={differenceTime}
          />
        </div>
        <HTMLContent
          html={news?.description}
          className="text-left text-sm text-black ion-text-wrap news-content mt-12"
        />
      </div>
      <Faq faq={news?.faq} />
      <Form postId={news?.postId} form={news?.form} />
      {news?.gform?.gform_activation === true && news?.gform?.gform && (
        <GForm form={news?.gform.gform} />
      )}
    </div>
  );
};
